import React, { useContext } from 'react'
import Context from '../../context/Context'
import { DateFormatter } from '../../utils/DateFormatter'

const PaymentInformation = () => {
  const context = useContext(Context)

  return (
    <div className="row mt-5">
      <div className="col-8 offset-1 col-sm-5 offset-sm-2">
        {context.invoice.total_amount >= 0 &&
          <div>
            <span className="paragraph-bold-14">Förfallodatum: </span>
            <span className="paragraph-regular-14">{DateFormatter.formatMonth(context.invoice.due_date)}</span> <br />
          </div>
        }
        <span className="paragraph-bold-14">OCR: </span>
        <span className="paragraph-regular-14">{context.invoice.ocr}</span><br />
        <span className="paragraph-bold-14">Bankgiro: </span>
        <span className="paragraph-regular-14">{context.organizationSettings.bankgiro}</span><br />

        {context.organizationSettings.showInvoiceLines === '0' &&
          <div>
            <span className="paragraph-bold-14">Belopp att betala: </span>
            <span className="paragraph-regular-14">{context.invoice.remaining_amount} kr</span><br />
          </div>
        }

      </div>
      <div className="col-3 col-sm-2 offset-sm-2">
        <a href={context.invoice.invoice_pdf} target="_blank" rel="noopener noreferrer" title="Visa faktura">
          <img className="img-fluid" src="/images/pdf.png" alt="Visa faktura" />
        </a>
      </div>
    </div>
  )
}

export default PaymentInformation
